// extracted by mini-css-extract-plugin
export default {"base":"components-Pagelayout-styles__base--aR9wz","lockBody":"components-Pagelayout-styles__lockBody--MjWye","scrollToContent":"components-Pagelayout-styles__scrollToContent--aoIHn"};